import { forwardRef } from 'react';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

const StyledMenusWrapper = styled.div`
  display: flex;
  overflow: auto;
  width: fit-content;
  ${({ border }) =>
    border ? `border: 1px solid ${getColor('botticelli')}` : ''};
  ${({ menuHeight }) => `max-height: ${menuHeight}`};
  ${({ menuWidth, numOfMenus }) => `
    min-width: ${menuWidth};
    max-width: calc(${parseInt(menuWidth) * numOfMenus}rem + ${parseInt(
    numOfMenus - 1
  )}px);
  `};
  ${({ isSearchMode, menuWidthExpanded }) =>
    isSearchMode && `max-width: ${menuWidthExpanded}`}
`;

const MenusWrapper = (
  {
    children,
    menuHeight,
    menuWidth,
    numOfMenus,
    isInline,
    isSearchMode,
    menuWidthExpanded
  },
  ref
) => {
  return (
    <StyledMenusWrapper
      menuHeight={menuHeight}
      menuWidth={menuWidth}
      numOfMenus={numOfMenus}
      border={isInline}
      isSearchMode={isSearchMode}
      menuWidthExpanded={menuWidthExpanded}
      ref={ref}
    >
      {children}
    </StyledMenusWrapper>
  );
};

export default forwardRef(MenusWrapper);
